import React, { useState, useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import { Helmet } from 'react-helmet';
import api from '../../services/api';
import { Spin } from 'antd';

const PrivacyPolicy = () => {
  const [policy, setPolicy] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPrivacyPolicy();
  }, []);

  const fetchPrivacyPolicy = async () => {
    try {
      const response = await api.get('/privacy');
    if (response.data.success && response.data.data) {
      setPolicy(response.data.data);
    }
    
   
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-page">
      <Helmet>
        <title>Privacy Policy - Startup Business Partners</title>
      </Helmet>
      
      <Navbar />
        
      {/* ================================================
          BREADCRUMB
      ================================================= */}
     <section
  style={{
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
    padding: '40px 0',
    color: '#fff'
  }}
>
  <div className="container text-center">

    <h1
      style={{
        fontSize: 42,
        fontWeight: 700,
        marginBottom: 18,
             color:'#fff'
      }}
    >
Privacy Policy
    </h1>

    <p
      style={{
        fontSize: 19,
        opacity: 0.9,
        maxWidth: 850,
        margin: '0 auto 15px',
        lineHeight: 1.7
      }}
    >
 Learn how we collect, use, protect, and manage your personal information when you explore our plans, purchase our services, and interact with our platform.
    </p>


  </div>
</section>
      <section className="sectionbg p-top-100 p-bottom-110">
        <div className="container">
         
          
          <div className="row">
            <div className="col-lg-12">
              {loading ? (
                <div className="text-center">
                  <Spin size="large" />
                </div>
              ) : (
                <div className="card">
                  <div className="card-body">
                    {policy ? (
                      <>
                        {/* <h4 className="mb-4">{policy.title}</h4> */}
                        <div dangerouslySetInnerHTML={{ __html: policy.content }} />
                      </>
                    ) : (
                      <p>No privacy policy found.</p>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;